export const APP_LOADING_BEGIN = 'APP_LOADING_BEGIN';
export const APP_LOADING_END = 'APP_LOADING_END';
export const TOGGLE_COLLAPSED = 'TOGGLE_COLLAPSED';
export const CHANGE_HEADER_TITLE = 'CHANGE_HEADER_TITLE';
export const UPDATE_LINK_POLICY = 'UPDATE_LINK_POLICY';
export const UPDATE_LINK_LGPD = 'UPDATE_LINK_LGPD';
